<div class="flex flex-col p-6 pb-0">
  <div class="flex justify-between">
    <h1>Підтвердження створених призначень</h1>
    <button
      mat-dialog-close
      (click)="closeDialog(false)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex gap-4">
    @if (clientProfileInfo) {
      <p class="paragraph-1 text-neutral-300">Створені для клієнта:</p>
      <p class="paragraph-1 gap-2 text-neutral-500">
        {{ clientProfileInfo.fullName }}
        @if (!!age || !!clientProfileInfo.gender) {
          <span class="text-sm">
            (
            @if (!!age) {
              <span>{{ age + " р., " }}</span>
            }
            @if (clientProfileInfo.gender.toLowerCase() === "male") {
              <span>чоловік</span>
            } @else if (clientProfileInfo.gender.toLowerCase() === "female") {
              <span>жінка</span>
            }
            )
          </span>
        }
      </p>
    }
  </div>
</div>
<div class="mb-6 mt-4 flex flex-col gap-4 overflow-y-auto px-6">
  @if (medications()?.length > 0) {
    <div class="flex flex-col gap-2">
      <div class="flex justify-between">
        <p class="subheader-1 text-neutral-500">Лікарські засоби</p>
      </div>
      <div class="flex flex-col gap-2">
        @for (medication of medications(); track $index) {
          <div class="flex justify-between gap-2 rounded-xl border-2 border-solid border-neutral-100 bg-neutral-100 p-2">
            <div class="subheader-2 flex items-center gap-2 text-neutral-500">
              <p>{{ $index + 1 }}.</p>
              <p>{{ medication.name }}</p>
            </div>
            <div class="flex items-center gap-2">
              <p class="paragraph-3 text-neutral-300">Кількість</p>
              <p class="subheader-2 text-neutral-500">{{ medication.metadata.treatment_dose }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (!!personalDoctor()) {
    <div class="flex flex-col gap-2">
      <div class="flex justify-between">
        <p class="subheader-1 text-neutral-500">Візит до персонального лікаря</p>
      </div>
      <div class="flex justify-between gap-2 rounded-xl border-2 border-solid border-neutral-100 bg-neutral-100 p-2">
        <div class="subheader-2 flex items-center gap-2 text-neutral-500">
          <p>{{ medications().length + 1 }}.</p>
          <p>{{ personalDoctor().name }}</p>
        </div>
        <div class="flex items-center gap-2">
          <p class="subheader-2 text-neutral-500">{{ personalDoctor().metadata.doctor_name }}</p>
        </div>
      </div>
    </div>
  }
  @if (services()?.length > 0) {
    <div class="flex flex-col gap-2">
      <div class="flex justify-between">
        <p class="subheader-1 text-neutral-500">Медичні послуги</p>
      </div>
      <div class="flex flex-col gap-2">
        @for (service of services(); track $index) {
          <div class="flex justify-between gap-2 rounded-xl border-2 border-solid border-neutral-100 bg-neutral-100 p-2">
            <div class="subheader-2 flex items-center gap-2 text-neutral-500">
              <p>{{ medications().length + (personalDoctor() ? 1 : 0) + $index + 1 }}.</p>
              <p>{{ service.name }}</p>
            </div>
            <div class="flex items-center gap-2">
              <p class="paragraph-3 text-neutral-300">Кількість</p>
              <p class="subheader-2 text-neutral-500">{{ service.metadata.quantity }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="flex grow items-center justify-end gap-4 p-6 pt-0">
  <button
    class="btn btn-secondary"
    (click)="closeDialog(false)"
  >
    Скасувати
  </button>
  <button
    class="btn btn-primary"
    (click)="closeDialog(true)"
  >
    Підтвердити створення
  </button>
</div>
